<template>
  <LayoutAuthPrimary>
    <div :style="style.container">
      <BeatLoaderPrimary>
        <template v-slot:header>
          <TextRegular :isInline="true">
            Securely redirecting you to an external sign-in page.
          </TextRegular>
        </template>
        <template v-slot:footer>
          <TextRegular :isInline="true">
            The email domain of
          </TextRegular>
          <TextEmailPrimary :isInline="true">
            {{ inheritedState.email }}
          </TextEmailPrimary>
          <TextRegular :isInline="true">
            is recognized by {{ appName }} and uses Single Sign-On for easy access.<br>
          </TextRegular>
        </template>
      </BeatLoaderPrimary>
    </div>
  </LayoutAuthPrimary>
</template>

<script>
  import BeatLoaderPrimary from '@modules/v2/loader/beat-loader-primary'
  import LayoutAuthPrimary from '@modules/v2/layout/layout-auth-primary'
  import TextEmailPrimary from '@modules/v2/text/text-email-primary'
  import TextRegular from '@modules/v2/text/text-regular'
  import { APP_NAME } from '@js/constants'

  export default {
    name: 'SsoRedirectView',
    components: {
      BeatLoaderPrimary,
      LayoutAuthPrimary,
      TextEmailPrimary,
      TextRegular,
    },
    data: function () {
      return {
        appName: APP_NAME,
        inheritedState: {},
        unregistered: false,
        waitPeriod: 3000,
        style: {
          container: {
            alignItems: 'center',
            display: 'flex',
            flex: 1,
            justifyContent: 'center',
            maxWidth: '600px',
            width: '90%',
          },
        },
      };
    },
    created: async function () {
      this.inheritedState = this.$route?.params?.state;
      if (
        !this.inheritedState ||
        !this.inheritedState?.ssoAuthorizationUrl ||
        this.inheritedState.ssoAuthorizationUrl.length === 0
      ) {
        this.$router.push({ name: 'login-continue' });
        return;
      }
    },
    mounted: function () {
      setTimeout(() => {
        window.open(this.inheritedState.ssoAuthorizationUrl, '_self');
      }, this.waitPeriod);
    },
  };
</script>
